module.exports = __webpack_public_path__ + "img/green_093.b269a24c.png";